import React from "react";
import { Link } from "react-router-dom";
import { X, Plus, Minus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { formatMXN } from "../lib/api";

export const CartDrawer = () => {
  const { items, removeItem, setQty, subtotal, drawerOpen, setDrawerOpen } = useCart();
  if (!drawerOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex" data-testid="cart-drawer">
      <div className="flex-1 bg-black/40" onClick={() => setDrawerOpen(false)} />
      <aside className="w-full sm:w-[420px] bg-[#F9F6F0] flex flex-col shadow-2xl animate-fade-up">
        <div className="flex items-center justify-between px-6 py-5 border-b border-[#E8E3DA]">
          <h3 className="font-serif text-2xl tracking-tighter">Tu bolsa</h3>
          <button onClick={() => setDrawerOpen(false)} data-testid="cart-close" aria-label="cerrar"><X size={20} /></button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-6">
          {items.length === 0 ? (
            <p className="text-sm text-[#5B605E]">Tu bolsa está vacía. <Link to="/catalogo" onClick={() => setDrawerOpen(false)} className="link-underline text-[#A94438]">Explorar</Link></p>
          ) : items.map((it) => (
            <div key={it.key} className="flex gap-4" data-testid={`cart-item-${it.slug}`}>
              <img src={it.image} alt={it.name} className="h-24 w-20 object-cover" />
              <div className="flex-1">
                <div className="flex justify-between">
                  <Link to={`/producto/${it.slug}`} onClick={() => setDrawerOpen(false)} className="font-serif text-base">{it.name}</Link>
                  <button onClick={() => removeItem(it.key)} className="text-xs text-[#5B605E] hover:text-[#A94438]" data-testid={`remove-${it.slug}`}>Quitar</button>
                </div>
                {(it.size || it.color) && (
                  <p className="text-xs text-[#5B605E] mt-1">{[it.size, it.color].filter(Boolean).join(" · ")}</p>
                )}
                <div className="mt-3 flex items-center justify-between">
                  <div className="flex items-center border border-[#2C302E]">
                    <button onClick={() => setQty(it.key, it.qty - 1)} className="px-2 py-1" data-testid={`dec-${it.slug}`}><Minus size={14} /></button>
                    <span className="px-3 text-sm">{it.qty}</span>
                    <button onClick={() => setQty(it.key, it.qty + 1)} className="px-2 py-1" data-testid={`inc-${it.slug}`}><Plus size={14} /></button>
                  </div>
                  <span className="text-sm font-medium">{formatMXN(it.price * it.qty)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t border-[#E8E3DA] px-6 py-5 space-y-4">
            <div className="flex justify-between text-sm">
              <span>Subtotal</span><span data-testid="cart-subtotal">{formatMXN(subtotal)}</span>
            </div>
            <p className="text-xs text-[#5B605E]">Envío y descuentos calculados al pagar.</p>
            <Link to="/carrito" onClick={() => setDrawerOpen(false)} data-testid="go-to-cart" className="btn-primary w-full">
              Pagar →
            </Link>
          </div>
        )}
      </aside>
    </div>
  );
};
